<template>
  <b-card no-body>
    <b-card-header>
      <h4 class="mb-0">
        Açık Görüşmeler
      </h4>
      <b-card-text class="font-medium-5 mb-0">
        <feather-icon
          v-b-tooltip.hover.v-primary.left
          title="Son 10 açık görüşme"
          icon="HelpCircleIcon"
          size="21"
          class="text-muted cursor-pointer"
        />
      </b-card-text>
    </b-card-header>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      hover
      small
    >
      <template #cell(customer)="data">
        <div
          class="d-flex align-items-center cursor-pointer"
          @click="$router.push('/app/interviews/view/' + data.item.id)"
        >
          <div>
            <div>
              {{ data.item.customer }}
            </div>
            <div class="font-small-2 text-warning">
              {{ data.item.interview_status }}
            </div>
            <div
              v-if="data.item.modified"
              class="text-muted font-small-2"
            >
              {{ moment(data.item.modified).format('ll') }}
            </div>
            <div
              v-else
              class="text-muted font-small-2"
            >
              {{ moment(data.item.created).format('ll') }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(interview_subject)="data">
        <div
          class="cursor-pointer"
          @click="$router.push('/app/interviews/view/' + data.item.id)"
        >
          <div>
            {{ data.item.interview_subject }}
          </div>
          <div class="text-muted">
            {{ data.item.username }}
          </div>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardText, BTable, VBTooltip,
} from 'bootstrap-vue'

export default {
  name: 'Interviews',
  components: {
    BCard,
    BCardHeader,
    BCardText,
    BTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'customer',
          label: 'MÜŞTERİ',
          tdClass: 'font-small-2',
        },
        {
          key: 'interview_subject',
          label: 'KONU',
          tdClass: 'font-small-2',
        },
      ],
    }
  },
}
</script>
